import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServicesService } from '../auth/services/auth-services.service';
import { Store } from '@ngrx/store';
import { clearReducer } from '../auth/state/auth.actions';
import { MigrationPopupService } from '../click-it/services/migration-popup.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardModuleGuard  {
  OtpData: any;
  constructor(
    private authService: AuthServicesService,
    private router: Router,
    private store: Store<any>,
    private migrattionPopUp: MigrationPopupService
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.OtpData = data?.authReducer?.otpVerifiedDetails;
      });
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.isLoggedIn()) {
      return true;
    } else {
      if (!this.OtpData?.tnc_accepted) {
        this.authService.logout().subscribe({
          next: (res) => {
            if (res.msg === 'Logout successfully!') {
              console.log(localStorage.getItem('languageDirection'));
              this.store?.dispatch(clearReducer());
              this.migrattionPopUp.stopPopupCheck();
              localStorage.removeItem('lastPopuptime');
              this.router.navigate(['login']);
            }
          },
          error: (err) => {},
        });
      }
      this.router.navigate(['login']);
      return false;
    }
  }
}
